import * as Sentry from '@sentry/react';
import { useMutation } from '@apollo/client/react';
import { ZUGANG_LOESCHEN } from '../lib/graphql/mutations';

export type ZugangLoeschen = {
  loescheZugang: () => Promise<boolean>;
  loading: boolean;
};

export function useZugangLoeschen(uidZugang: string): ZugangLoeschen {
  const [loeschen, { loading }] = useMutation(ZUGANG_LOESCHEN, {
    update(cache, { data }) {
      if (data?.loescheZugang.__typename !== 'ZugangLoeschenSuccess') {
        return;
      }
      cache.evict({
        id: cache.identify({ __typename: 'Zugang', uid: uidZugang }),
      });
      cache.gc();
    },
  });

  async function loescheZugang(): Promise<boolean> {
    try {
      const { data } = await loeschen({ variables: { uidZugang } });
      return data?.loescheZugang.__typename === 'ZugangLoeschenSuccess';
    } catch (error) {
      Sentry.captureException(error);
      return false;
    }
  }

  return { loescheZugang, loading };
}
